import React from "react";
// import "./Membership.css";

export default function Membership() {
  return (
    <div className="membership">

      {/* HEADER */}
      <div className="membership-header">
        <h1>સભ્યતા યોજના</h1>
        <p>
          અમારી સોસાયટીમાં સભ્ય બનીને વિવિધ બચત, લોન અને વીમા યોજનાઓનો લાભ મેળવો.
        </p>
      </div>

      {/* CARDS */}
      <div className="cards">

        <div className="card">
          <div className="icon">💰</div>
          <h3>લાભ</h3>
          <ul>
            <li>બચત અને ડિપોઝિટ</li>
            <li>સરળ લોન સુવિધા</li>
            <li>વીમા લાભ</li>
            <li>ઉચ્ચ વ્યાજ દર</li>
          </ul>
        </div>

        <div className="card">
          <div className="icon">📄</div>
          <h3>દસ્તાવેજ</h3>
          <ul>
            <li>આધાર કાર્ડ</li>
            <li>પાન કાર્ડ</li>
            <li>ફોટોગ્રાફ</li>
            <li>સરનામું પુરાવો</li>
          </ul>
        </div>

        <div className="card highlight">
          <div className="icon">₹</div>
          <h3>સભ્ય ફી</h3>
          <p className="price">₹1000</p>
          <span>એક વખતની નોંધણી ફી</span>
        </div>

      </div>

      {/* STEPS */}
      <div className="steps">
        <h2>સભ્ય બનવાની પ્રક્રિયા</h2>

        <div className="step-container">
          <div className="step">1. ફોર્મ ભરો</div>
          <div className="step">2. દસ્તાવેજ સબમિટ કરો</div>
          <div className="step">3. ચકાસણી પ્રક્રિયા</div>
          <div className="step">4. સભ્યતા મંજૂર</div>
        </div>
      </div>

      {/* BENEFITS STRIP */}
      <div className="benefits">
        <div>✔ ઝડપી લોન</div>
        <div>✔ સુરક્ષિત બચત</div>
        <div>✔ વિશ્વાસપાત્ર સેવા</div>
        <div>✔ આકર્ષક વ્યાજ</div>
      </div>

      {/* CTA */}
      <div className="cta">
        <h2>હવે જોડાઓ</h2>
        <p>આજે જ સભ્ય બનીને તમારા ભવિષ્યને સુરક્ષિત બનાવો</p>
        <button>હવે અરજી કરો</button>
      </div>

    </div>
  );
}